let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("elHYe")).then(() => parcelRequire('7Kbkn'));